import React, { useState, useEffect } from "react";
import { Col, Row, Typography, } from 'witmeg-ui-system'
import { useHistory } from 'react-router'
import "./HospitalityDefaultOrderPage.scss"
import { useSelector, useDispatch } from 'react-redux';
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { getCartItemsToCart, getFloorDetails, placeOrder } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import { Select } from "antd";
import { setOrderData, setOrderEmpty, setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import locationIC from "../../assets/location.svg"
import arrow from "../../assets/images/down-arrow.svg"
import cardIc from "../../assets/card.svg"
import cashIc from "../../assets/cash.svg"
import cartIc from "../../assets/cart-gray.svg"
import { getRestaurantMenuSettingsData } from "../../../../../utilities/apiRequests/neutriPosServerRequests";
import { sendPaymentDetails } from "../../../RestaurantWidget/utilities/api/paymentService";
import HospitalityDefaultPaymentContainer from "../HospitalityDefaultPayment/HospitalityDefaultPaymentContainer";
import Footer from "../../components/Footer/Footer";

const HospitalityDefaultOrderSummaryPage = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [floorData, setFloorData] = useState([])
    const [tables, setTables] = useState([])
    const [selectedFloor, setSelectedFloor] = useState(null)
    const [selectedTable, setSelectedTable] = useState(null)
    const { Option } = Select;
    const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
    const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
    const [dineInError, setDineInError] = useState(false)
    const [isLoading, setIsLoading] = useState("")
    const [isCollapsed, setIsCollapsed] = useState("closed")
    const [isCardPayment, setIsCardPayment] = useState(false)
    const [isOrderLoading, setIsOrderLoading] = useState(false)
    const [paymentTypes, setPaymentTypes] = useState([])
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)


    const dispatch = useDispatch()
    let history = useHistory();
    const search = history.location.search;
    const params = new URLSearchParams(search);
    const redirectResult = params.get('redirectResult');

    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const IMAGE_PLACEHOLDER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAADCCAIAAADCcDA5AAAStUlEQVR4Ae2dPY+ruhaGz9863e5GqSiRaCxRJA0tCj11poo0EjUVXST+QSqaVClpERIdSC5MdedmbXzYJGHCh7P5eCkGD8HGfr0elm2w+afABgWgQFH8AxGgABQoQAKMAAqQAvAJsAQo8H8FQALsAAqABNgAFKgUgE+olMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QqAhHXXP0pfKQASKiWwX7cCIGHd9Y/SVwqAhEoJ7NetAEhYd/2j9JUCIKFSAvt1KwAS1l3/KH2lAEiolMB+3QosjQTOuRCiKIocmxoFiqIQQnDOFwbOokjgnIdh6DjODptKBRzHCcOQ37bF8LAcErIscxzHMIwtNvUKGIbhOE6WZSBhWgp8+2vbtk3T3G63pmka2FQqIHW2bZvaotOyhl65WYJP4Jyfz2fyBoyx4/EYY1OpwPF4ZIxtt1vDMM7n8zL6DEsgQQhxOBzM23Y4HMqypCYs/ipSoCxLEny73R4Oh2W4hSWQwDnf7/fb7VbX9SiKlnGL6uXh3xSJc365XHRd3263+/1+GYIvhATbtomEy+WyjIp5k1H3ukydBNu2lyE4SOhlC+uOBBImWv/frWH4hHfWDUh4p9odrgUSOog1xqkgYQwVFaQBEhSI2pYkSGhT5y/+BhLeLD5IeLPgr14OJLyq1EjngYSRhBw7GZAwtqI/pAcSfhDob/0MEt6sPEh4s+CvXg4kvKrUSOeBhJGEHDsZpSTQ1B9x25bxMHW4/CBhuIZKUlBEghAiz/Moik6nUxAEYRher1c5J05JSWaSKEiYaEWNToIQIk3T4/FIL/kzxkzTZIwZhsEYC4KgKIo1+weQsAoShBBRFJH1P5z7xRizLCuO49XCABKWTwJhQO8bP8RAHmSMJUmyThhAwvJJSNP0FQyIB8uyQALeyp4QFWP1E4QQx+ORJunKe39LgDEWhuEyZmx1qk74hE5yve/ksUhI05Sm57ZYf+Onv3VHpFHdvzW2CxLeZ9ydrjQKCZzzKIq6LhJjGEaSJJ1yO/BkIUSWZWEYep53PB5936c59e9sp4GEgZWoKvpYJARB0NUn6Lr+zvminHPf92kwl1YwoCVtTNM8n89va6eBBFWmPDDdUUgQQvi+35UEwzDeuYaA67rPvJau60EQvAcGkDDQYlVFH4UEzvnpdOpKwtt8ghDi6+urPXu0+tAbYAAJqkx5YLpjkTDZfoIQ4nw+vzK8yxhL03Sgnj9GBwk/SvR3ThiFhKIosix7fQiVBpHesNoP5zzLsnZvIEe0TNN0HKcsS6U1ARKUyts/8bFIEEJ4nvc6DO9ZC5Fz7rpup1ydTielbSSQ0N9YlcYciwT66sKzLqm871KA7r5KDY6+VHA6nV7MksyhYRhKX4sCCUrtuX/iI5LAOb9erz9aHt2hVa+ZzjmP4/iV7oFkQAaUvgkCEvobq9KYI5JAt+E4ji3LetY013Xddd0sy1Q/zMrz3LIsadydAowxz/MUdRhAglJ77p/4uCTQ3IM8z4MgoLVW6UmWYRi6rluW9Z5numVZep73jMZXqFD3rAMk9DdWpTFHJ4FyS2/1xHF8vm1RFCVJQkvSKy0OoRhFUb92UR0S0zRVNOFAgmoD6Jm+IhIoN9+Jy61n/rpHy7KsbtC9w6Zpuq47ehsJJHSv0rfE+LbUJa0QLIToNGzazolhGKO/Og4S3mLX3S+yJBKEEGEY/jh41W79jV8ZY+MOqoKE7kb6lhiLIYGGTcfFgKiwLGvERx8g4S123f0iiyHhu69MzbzGTX34v4wx3/fHggEkdDfSt8RYBgllWfZ4Lfx1SAzDoPWahtcJSBiuoZIUFkACPdsePmzaDoZpmnmeD68DkDBcQyUpLICEPM93u127HQ//1TRN+krvwGoACQMFVBV97iTI70kPt/UfUxhlNg9IUGXKA9OdNQk0C0fFeNEzKoavWQYSBlqsqujzJYFzniTJkJeLnpl7y3HTNPf7/ZBxJJCgypQHpjtrEhzHeX0WTot9d/qJ1jnuDQNIGGixqqLPlISyLHusK9PJ4ltOHjKoChJUmfLAdOdIwnuGTVtIoJ/6KQ8S+ummPJZqEuRndUacmjNkFs6P9v3iCYyx4/HY401VkKDcpvtdQBEJBECSJOfzObhtURTled67eS1LR0sRv7mj/BCPfoOqIEFW5bQCKkigUZ3D4aDrOs1ZY4zpuk4v8Hxfsbd/eH3xooe2O/rBHkskgYRpASBzMzoJQojr9frsszqMMcdx8jzvAQPnPE3T9w8WtfDTY4kkkCBtb1qBcUkgDNofddGQfA8Yxp2F02LfnX4yDKPTEkkgYVoAyNyMSIIQIo7jV1rwdCvt9OlBIUSPxYs62XTvkzstkQQSpO1NKzAWCV3XFzJN07btFz1D18R723TviLvd7sX2HkiYFgAyN6OQQJb6ijeomxrB8KJnUDQLp56fIWFaIumVkTGQIG1vWoHhJLzeKLo3tVf6DMMXL7q/roojLy6RBBKmBYDMzUAS+nmDuiG2N5Pou1WqZ+HU8zMk/MoSSSBB2t60AkNIIAyGD2u2eIaxFi8aYt+vx31liSSQMC0AZG56k0AYtA+YdrKh+w501zXfX7+cujN/XCIJJEjbm1agHwn0FHlce2p0oOk1O03Txr3KG1JjrUskgYRpASBz04MEwmAsb1A3zUafQcVKXvXLqQu3LJEEEqTtTSvQlQQV3qBukQ3PQDDMpccsC9KyRBJImBYAMjedSCAMhneRpcU8DDQ60GVZjr7G48PrjnvQMIyHX5sGCdL2phV4nYT3YEDmuIxm0sMlkkDCtACQuXmRBHoP9A3LCskbc6OZRJ5hXs2kh0skgQRpe9MKvEICYdD1ZQpp070DDc8wx2bS/aAqSJgWADI3P5JAGPT+ZllvDChiwzPMsQPdWCIJJEjbm1agnQT6svdAax4YfQGewbZt+XIeSJgWADI3LST8XW9Q56cBw+w8Q32JJJAgbW9agWckkDewLEv1mGnd4lvCDRhm12eQSySBhGkBIHPzkATCYLfbTQQDImTuMHzn/1ttkCBtb1qBexI4599TyWzbnhQGdRjk5J55NZNM06Qlki6XCw0H27b94ky3aRnNXW7+uTsyvwP3JNDnCCaIQR2GLMvIhubVTKIlkq7XK0iYHCoNEibrDepdiEYzaXae4Xw+0/uL8AkT4kGSQJMPp9koqmOwAM8giwMSpkiCtDBZTxMPzNozkLYgYbokTNz6G9mbOwwgASQ0TLr/vwSD7EBTn0HFLKL+WXweEySAhOfW0f0XgkEOrdK3mSc79lUvH0gACXV7GCFc9wxCiCiKZuEWQMK0SHAcZwRj/NtJEAzxbZv4gnlSKsdx8GRtKjDQhzlm0ZaQBtQSMG5bywnT+YkeOct3VKdiEL3ysZBnzPKR53SsZA050XX9er3CJ/RCT00kcguzaFgvhhDDMPp9pk2NCQxNdQk+gTTgnPu+T1+CWkxLaYLYmKbJGDMMw/f9ZXgDsp/lkFAUBS157fu+i02ZAofDwff9OI6X0T2QrmRRJNB4vLhtZVlSAH9VKLAkb7BAnyD5RgAKdFVgaT6ha/lxPhQgBUACLAEK/F8BkAA7gAIgATYABSoF4BMqJbBftwIgYd31j9JXCoCESonb/ntK9LOR8mfH/4j//B8hxMAUnqeNX0ZQACT8J2KWZWEYRlF0b7JJkoRhmOf5f2d3CaVpejqd4jjuEgnnvlUBkPBbbvoOp6ZphmFkWVavBFry7devX43j9XNawpTyv//++5Cxloj46Z0KgITfapO90rtlYRjWX6ohEjRN60dCURRxHDPGHn6p6Z2VjWu1KAAS/iBB07QgCBhj9QbScBI452VZ1tNsqRL89FcUAAl/kLDZbJIk0XX9fD5Lw31IgjRuGWivv7qTod6zjEhvyNHrgwSMPFJPkw5yzh/+SsfzPK+fVo9OJzyLXj9znWGQ8LveqXX08fGRZdn3m/f3H86ot47oy4Wu6xqGoeu64zjtU7eyLDsej0mSkLkfj8coir6j2LZNq4uGYViW5eVy2e/3uq6bphkEQR2eoih83zdNU9f13W53Op0kqJTm9Xq1LIvinm/b4XCQ5wghzucznbDdboMgkD+t0+7vSw0SmiSkaZokiaZp0rjvfQL5jcPhcL1tnudtNht5/r3KWZb9+vUrjmO6Jdu2TUsQRFEUx7Hv+5qmfX5+MsaiKEqSJAgCTdNkd0UIcTgcTNOk8+lX6bVkX9/zvDiOCQnrtpG5Ewaapp3P5yRJLpeLaZpfX18N0u6zvaojIOF3dUufkCRJWZaH20a20iChLMvj8UhOg54/0JH9fv/MtrIs+/j4kCTs9/vtdpumKTWTyrIk91I/8vn5ud/vyZTTNN1sNpfLpX7+4XCgy1F013VloytNU8aYZVkUPc9zcjKy6RXHsaZp5KNWZe4thQUJD0ggKjabDT0BaJDAOb/vSFyv1xbbapBg27bv+xIbIYTnebZtl2VJuaFl8MiUKTOu68qRKyGE7/uO48gU6H4vGzzkQ2T06/VKrT5pB2VZ0uLvMor8abUBkPC76us+gSaC7vd7z/PoPnq5XKifQB9uI0jqZpSmqaZpz8ZJh5AgJ+JJGy3L0vM8SUKSJB8fH/W2mRAiCILdbkcu63w+67ouPQb11B3Hue+KyEusMAASHpPAOY+iaLPZfH+Noe4TOOd0+0/TtGEuDUdR/3UgCZQU9TGKoqBvF8jmEFGaJIkkk3MehiGRQFRst9skSWhNMfrrOI7nedKr1HO7zjBI+F3vDZ9Ad+LdbhcEAY3qSJ8QRZGu67KtIs1U1/UwDKU51u1pOAm0WIHneYZh7HY7mq9Pt3m65dfJpC7ydrsleHzfZ4ztdrv6ShmWZdVbaPXcrjMMEn7X+z0J1Fg3TbMoinrr6P0k0H1d0zTXdS+XS1mWQRBQ64hzTiTUyaSDdRIsy6JmHrWX5N91Gv3DUoOEpySQW6DOKLWIaGF3IqF+Dy6KIs/zRre1LvcQnyDbY/TMgW7zdRLo43/1/BDD9dbRbreT3XHKGPmTeiZXHgYJvw3g3idQv5mestVJoCFIGhKV1qOux0wjRaZpyjY9uYh6j7nRg2/0mMMwNAxDRqdyBUGANwJl9WEe839SPCShKAp6yhYEgewb5Hm+2Wzkgy1yHQ8dhUx9iE+4H2OlxxfUY6ZLNNyREOLz81OOol4ul8YoqhCipX8vs72qAHzC7+p+RgJZFS2BSG3xsiwdx3FdV7Y3yrL8/PyUN+l7AxpIgnwpULbvTdOUJFB+HMeh/NAn2U3TlE/WsiwzDON0OtEJ1PluuJH7PK/tCEj4g4Rfv341nrwSIbquy3kLdETTtK+vr+S2fbc0Or1t0Ri3EUJ8fX1Rp5ZyI4Q4nU7ygQC1x+hy9LaSbduMMXqGIDsSdEIcx5Zl7XY7SQJ1G8hvJElyvV6XtNr7WMSChP+UTJLEdd1611Paped5n5+fcnxGCHG9Xh3H0W+bbdtRFNUb4v8legtlWea6rnxi7XlefbyVhv/ro/v0NOP7wTONycpRUU3TGGOn0ynLMue20UXpGzy73Y5mGoW3jUCSRaAnDLquM8YWtrhvQ+1+/4KEP3R7Zs33L0JTQyW/bRT+I6G7f+op358vn5rJeI0jFIVQJDzqiQghaJBUtt/kM+Z6gpxzmoBaz4w8YeUBkDB7A6CeTP3VCSGE67ot/ZbZl1lBAUCCAlHfmyTn/HQ6aZpGo6Kcc+q3YJC0Uz2AhE5yTfRkeuag6/rmtjHG5NyGieZ4etkCCdOrk145EkJkWXa9XuM4pjmcvZJZbySQsKi6r3ejF1Uw9YUBCeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qAASJhDLSGP6hUACeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qAASJhDLSGP6hUACeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qAASJhDLSGP6hUACeo1xhXmoABImEMtIY/qFQAJ6jXGFeagAEiYQy0hj+oVAAnqNcYV5qDA/wB2ys2dB7jqeAAAAABJRU5ErkJggg==';
    const orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : ""
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null


    const getPaymenttypes = async () => {
        const paymentSettings = await getRestaurantMenuSettingsData({
            SettingType: "PaymentMethods",
            CloudLocationID: storeOrderLocalData.cloudLocationID,
        })
        setPaymentTypes(paymentSettings.map((type) => type.PaymentMethod))
    }
    useEffect(() => {
        if (orderID === "" && customerDetails) {
            history.push("/")
        } else {
            getPaymenttypes()
            setIsCardPayment(redirectResult ? true : false)
        }
    }, [])
    useEffect(() => {
        if (redirectResult) {
            sendPaymentDetailsRedirect()
        }
    }, [])
    useEffect(() => {
        if (defaultDetails && defaultDetails.defaultOrderType === "table" && restaurantDataState.orderDetails.FulfillmentType === "DINE_IN") {
            getFloorDetails().then((response) => {
                if (response) {
                    setFloorData(response)
                    let value = response.map((floor) =>
                        floor.Tables.map((table) => {
                            if (table.LocalID === defaultDetails.tableLocalId) {
                                let floorDataValue = {
                                    Id: floor.ID,
                                    Name: floor.ItemName.Translations.en,
                                    LocalReference: { Id: floor.LocalID }
                                }
                                let data = {
                                    TableID: table.ID,
                                    TableName: table.TableName,
                                    LocalReference: { Id: table.LocalID },
                                    Floor: floorDataValue
                                }
                                setSelectedFloor(floorDataValue)
                                setSelectedTable(data)
                                return data;
                            }
                            return null;
                        })
                    )
                        .flat()
                        .filter(Boolean)[0];
                    let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: value }
                    dispatch(setOrderData(updatedData))
                }
            })
        }
    }, [])
    useEffect(() => {
        if (restaurantDataState.orderDetails.FulfillmentType && restaurantDataState.orderDetails.FulfillmentType !== undefined) {
            let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType }
            if (restaurantDataState.orderDetails.FulfillmentType === "DINE_IN") {
                getFloorDetails().then((response) => {
                    if (response) {
                        setFloorData(response)
                        let selectedFloorValue = response[0]
                        let floorValue = {
                            Id: selectedFloorValue.ID,
                            Name: selectedFloorValue.ItemName.Translations.en,
                            LocalReference: { Id: selectedFloorValue.LocalID }
                        }
                        setSelectedFloor(floorValue)
                        let Tables = response?.find((floor) => floor.ID === floorValue.Id)?.Tables
                        if (Tables !== undefined) {
                            let selected = Tables[0]
                            let tableValue = {
                                TableID: selected.ID,
                                TableName: selected.TableName,
                                LocalReference: { Id: selected.LocalID },
                                Floor: selectedFloor
                            }
                            setSelectedTable(tableValue)
                            setTables(Tables)
                        }
                    }
                })

            } else {
                updatedData = { ...updatedData, DineIn: {} }
            }
            dispatch(setOrderData(updatedData))
        }

    }, [restaurantDataState.orderDetails.FulfillmentType])
    useEffect(() => {
        setSelectedTable(null)
        setTables([])
        setTimeout(() => {
            if (floorData) {
                let Tables = floorData?.find((floor) => floor.ID === selectedFloor.Id)?.Tables
                if (Tables !== undefined) {
                    let selected = Tables[0]
                    let tableValue = {
                        TableID: selected.ID,
                        TableName: selected.TableName,
                        LocalReference: { Id: selected.LocalID },
                        Floor: selectedFloor
                    }
                    setSelectedTable(tableValue)
                    setTables(Tables)
                }
            }
        }, 0);
    }, [selectedFloor, restaurantDataState.orderDetails.FulfillmentType])

    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (restaurantDataState.orderDetails.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const renderModifierGroups = (selectedGroup, item) => {
        return (
            <div>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title} <span className="qty-box">{Math.floor(selectedItem.Quantity.Amount / item.Quantity.Amount)}</span>
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup, item)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };

    const sendPaymentDetailsRedirect = () => {
        const paymentDetailsRequest = {
            cloudLocationID: storeOrderLocalData.cloudLocationID,
            reference: `Online-${storeOrderLocalData.cloudLocationID}-Ecom-${orderID}`,
            siteTransactionRef: orderID,
            store: `Ecommerce_${storeOrderLocalData.cloudLocationID}`,
            countryCode: "GB",
            paymentDetailInput: {
                redirectResult: redirectResult

            },
            shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),

        }
        setIsPaymentLoading(true)
        sendPaymentDetails(paymentDetailsRequest, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {

            if (response.resultCode === "Authorised") {
                let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                getCartItemsToCart(customerID, storeOrderLocalData.cloudLocationID).then((response) => {
                    if (response) {
                        if (response.Payment.Status === "COMPLETED") {
                            placeCartOrder("CARD", response)
                        } else {
                            history.push(`/order/failed`)
                        }
                    }
                })
            }
        })

    }
    const placeCartOrder = (type, updatedData) => {
        if (restaurantDataState.orderCartData.Items.length > 0) {
            setIsOrderLoading(true)
            setIsPaymentLoading(true)
            let data = { ...updatedData, PaymentType: type, OrderType: "MENU" }
            placeOrder(data).then((response) => {
                if (response) {
                    const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                    history.push(`/order/success/${oid}`)
                    dispatch(setOrderEmpty())
                    setIsOrderLoading(false)
                    setIsPaymentLoading(false)
                    dispatch(setSelectedOrderType(""))

                }
            }).catch((error) => {
                setIsOrderLoading(false)
                history.push(`/order/failed`)
            })

        }
    }



    return (
        <div className='HospitalityDefaultOrderPage '>
            {isPaymentLoading &&
                <div className="overlayer" ><div className="order-placing">Please wait your order in progress ...</div></div>
            }
            <div className="Order-confirmation">
                <div className="Order-confirmation-header">
                    <div className="header-text-cont">Checkout</div>

                </div>
                <div className="Order-confirmation-inner">
                    <div className="eco-mb-16 Order-confirmation-inner-left ">
                        {restaurantDataState.orderDetails.FulfillmentType === "DELIVERY_BY_REWARDCONSUMER" ? <div className="order-form-summary  eco-mb-36">
                            <div className="order-form-container">
                                <div className="form-header-text">Delivery Address</div>
                                <div className="address-conatinar">
                                    <div className="address-conatinar-left">
                                        <img className="loc-cont" alt="" src={locationIC} />
                                        <div className="customer-details-cont">
                                            <div className="customer-name-cont">
                                                <div className="name-text">{customerDetails?.Name?.FirstName} {customerDetails?.Name?.LastName}</div>
                                                <div className="address-tag">Main Address</div>
                                            </div>
                                            <div className="phone-number">{customerDetails.Contact.PinCode} {customerDetails.Contact.Number}</div>
                                            <div className="address">{customerDetails?.DeliveryAddress?.AddressLine1} {customerDetails?.DeliveryAddress?.StateProvinceRegion}, {customerDetails?.DeliveryAddress?.Country} {customerDetails?.DeliveryAddress?.PostZipCode} </div>
                                        </div>
                                    </div>
                                    <div className="address-conatinar-right">
                                        <a href={'/order/checkout'}>Edit Address</a>
                                    </div>
                                </div>
                            </div>
                        </div> :
                            <div className="order-form-summary  eco-mb-36">
                                <div className="order-form-container">
                                    <div className="form-header-text">Billing Address</div>
                                    <div className="address-conatinar">
                                        <div className="address-conatinar-left">
                                            <img className="loc-cont" alt="" src={locationIC} />
                                            <div className="customer-details-cont">
                                                <div className="customer-name-cont">
                                                    <div className="name-text">{customerDetails?.Name?.FirstName} {customerDetails?.Name?.LastName}</div>
                                                    <div className="address-tag">Main Address</div>
                                                </div>
                                                <div className="phone-number">{customerDetails.Contact.PinCode} {customerDetails.Contact.Number}</div>
                                                <div className="address">                                            {customerDetails?.BillingAddress?.AddressLine1} {customerDetails?.BillingAddress?.StateProvinceRegion}, {customerDetails?.BillingAddress?.Country} {customerDetails?.BillingAddress?.PostZipCode} </div>

                                            </div>
                                        </div>
                                        <div className="address-conatinar-right">
                                            <a href={'/order/checkout'}>Edit Address</a>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        {restaurantDataState.orderDetails.FulfillmentType === "DINE_IN" && <div className="order-form-summary">

                            <div className="order-form-container">
                                <div className="form-header-text">Selected Table</div>

                                <div className="floor-dropdown">
                                    <Row gutter={[16, 16]}>
                                        <Col lg={6} className="floor-drop-container">
                                            <div className="label">Floor</div>
                                            <Select className="select-floor"
                                                onChange={(id) => {
                                                    let selected = floorData.find((floor) => floor.ID === id)
                                                    let floorValue = {
                                                        Id: selected.ID,
                                                        Name: selected.ItemName.Translations.en,
                                                        LocalReference: { Id: selected.LocalID }
                                                    }
                                                    setSelectedFloor(floorValue)
                                                    setDineInError(false)
                                                }}
                                                value={selectedFloor ? selectedFloor.Name : ""}
                                            >
                                                {floorData && floorData?.map((floor, key) => {
                                                    return (
                                                        <Option value={floor.ID} key={key}>
                                                            {floor.ItemName.Translations.en}
                                                        </Option>
                                                    )
                                                }
                                                )}
                                            </Select>
                                        </Col>
                                        <Col lg={6} className="floor-drop-container">
                                            {tables.length > 0 && <>
                                                <div className="label">Table</div>
                                                <Select className="select-floor"
                                                    onChange={(id) => {
                                                        let selected = tables.find((table) => table.ID === id)
                                                        let tableValue = {
                                                            TableID: selected.ID,
                                                            TableName: selected.TableName,
                                                            LocalReference: { Id: selected.LocalID },
                                                            Floor: selectedFloor
                                                        }
                                                        setSelectedTable(tableValue)
                                                        setDineInError(false)

                                                    }}
                                                    value={selectedTable ? selectedTable.TableName : ""}
                                                >
                                                    <Option value=''>
                                                    </Option>
                                                    {tables && tables?.map((table, key) => {
                                                        return (
                                                            <Option value={table.ID} key={key}>
                                                                {table.TableName}
                                                            </Option>
                                                        )
                                                    }
                                                    )}
                                                </Select>
                                            </>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>}
                        <div className="order-form-summary-payment">
                            <div className="order-form-container">
                                <div className="form-header-text">Payment Options</div>
                                {paymentTypes.includes("cash") && <div className="payment-method" onClick={() => { setIsCardPayment(false) }}>
                                    {isCardPayment ? <div className="radio-btn" /> :
                                        <div className="radio-btn-selected">
                                            <div className="radio-btn-selected-inner" />
                                        </div>}
                                    <div className="itm-cont"><img alt="" src={cashIc} /></div>
                                    Cash </div>}
                                {paymentTypes.includes("card") && <div className="payment-method-2" onClick={() => { setIsCardPayment(true) }}>
                                    {!isCardPayment ? <div className="radio-btn" /> :
                                        <div className="radio-btn-selected">
                                            <div className="radio-btn-selected-inner" />
                                        </div>}
                                    <div className="itm-cont"><img alt="" src={cardIc} /></div>
                                    Card   </div>}
                                {isCardPayment && companyDetails.PaymentIntegration && companyDetails.PaymentIntegration.
                                    IntegrationName === "Wittally" && !redirectResult && <HospitalityDefaultPaymentContainer selectedTable={selectedTable} />}
                            </div>
                        </div>
                    </div>
                    <div className="Order-confirmation-inner-right">
                        {isCartDataAvailable ? <div className="order-form-summary">
                            <div className="order-form-container">
                                <div id="orderCart">

                                    <div className="form-header-text">Order Summary</div>
                                    {isCartDataAvailable ?
                                        <>
                                            <div className="header-conater"><div className="header-conater-left">
                                                <img alt="" src={cartIc} />
                                                <div className="form-header-text-cont">Cart Items</div>
                                                <div className="text-sub ">({restaurantDataState.orderCartData.Items.length}  {restaurantDataState.orderCartData.Items.length === 1 ? "item" : "items"})</div></div>
                                                <div className="header-conater-right"><img alt="" src={arrow} className={`arrow-${isCollapsed}`} onClick={() => {
                                                    if (isCollapsed === "open") {
                                                        setIsCollapsed("closed")
                                                    } else {
                                                        setIsCollapsed("open")
                                                    }
                                                }} /></div></div>
                                            {isCollapsed === "open" && <div className="order-cart-list" >
                                                {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                                    const _hasAddons = item.SelectedModifierGroups.length > 0;
                                                    return (
                                                        <div className="order-cart-item" key={index}>
                                                            <div className="order-cart-item-left">
                                                                <div className="cart-item-image-cont">

                                                                    <Typography
                                                                        style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                                        className="cart-item-image">
                                                                    </Typography>
                                                                </div>
                                                                <div className='item-details-container-left'>
                                                                    <div className='item-cart-title truncate-text'>{item.Title}</div>
                                                                    <div className="modifiers-text">
                                                                        {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                            <span key={index}> {renderModifierGroups(selectedGroup, item)} </span>
                                                                        ))}
                                                                    </div>
                                                                    <div className='item-cart-price'>  {isLoading === item.ID ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "20px" }}>{getPrice(item.PriceInfo.TotalPrice)}XXX</div>
                                                                        : getPrice(item.PriceInfo.TotalPrice)}</div>
                                                                </div>
                                                            </div>
                                                            <div className="order-cart-item-right">
                                                                <div className="qty-container">
                                                                    {item.Quantity.Amount}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>}

                                        </>
                                        :
                                        <div className="empty-cart">
                                            <div className="empty">
                                                <div className="empty-text  eco-mb-24"> No cart items</div>
                                                <div className="custom-btn-order" onClick={() => {
                                                    history.push("/")
                                                }}>Continue Shopping
                                                </div>

                                            </div>
                                        </div>}



                                    <div className="price-list">
                                        <div className="form-header-text">Order Total</div>
                                        <div className="price-list-inner">
                                            <div className="price-list-inner-left">Sub total</div>
                                            <div className="price-list-inner-right">    {restaurantDataState.orderDetails.Payment.
                                                PaymentDetail.OrderTotal.Net.Formatted}</div>

                                        </div>
                                        {restaurantDataState?.orderDetails?.Payment.
                                            PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                                return (
                                                    <div className="price-list-inner" key={key}>
                                                        <div className="price-list-inner-left">{fee.Description}</div>
                                                        <div className="price-list-inner-right">
                                                            {fee.Amount.DisplayAmount}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                    </div>
                                    <div className="price-list">
                                        <div className="price-list-inner-total" >
                                            <div className="total-value-text ">Total Price</div>
                                            <div className="total-value-text ">
                                                {restaurantDataState.orderDetails.Payment.
                                                    PaymentDetail.OrderTotal.Gross.Formatted}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!isCardPayment && <div className="custom-btn-order" onClick={() => {
                                    let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customerDetails }]
                                    let updatedData = { ...restaurantDataState.orderDetails, Customers: customerData, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: selectedTable ? selectedTable : {} }
                                    console.log(updatedData, "updatedData")
                                    if (restaurantDataState.orderDetails.FulfillmentType === "DINE_IN" && Object.keys(updatedData.DineIn).length === 0) {
                                        setDineInError(true)
                                    } else {
                                        setDineInError(false)
                                        dispatch(setOrderData(updatedData))
                                        if (!isOrderLoading) {
                                            placeCartOrder("CASH_ON_DELIVERY", updatedData)
                                        }
                                    }

                                }}>Confirm and Place Order</div>}
                                {dineInError && <Typography className="error-text">*Select a table and floor to continue</Typography>}
                                {redirectResult && <div className="custom-btn-order">Payment Inprocess</div>}
                            </div>
                        </div> : ""}
                    </div>
                </div>

            </div >
            <div className="footer-order">
                <Footer />

            </div>
        </div >
    )

}
export default HospitalityDefaultOrderSummaryPage